import IconDibLogo from "../assets/dib-logo.svg?react";
import classes from "./DibLogo.module.css";

const ASPECT_RATIO = 48.8 / 34;

type DibLogoProps = {
    height?: number;
};

export const DibLogo = ({height = 34}: DibLogoProps) => {
    const width = height * ASPECT_RATIO;

    return (
        <span className={classes.logo} role="img" aria-label="dib">
            <IconDibLogo width={width} height={height} aria-hidden />
        </span>
    );
};
